export enum FinancialTypesActionEnum {
  FINANCIAL_TYPES_LOADING = 'FINANCIAL_TYPES_LOADING',
  FINANCIAL_TYPES_SUCCESS = 'FINANCIAL_TYPES_SUCCESS',
  FINANCIAL_TYPES_FAILED = 'FINANCIAL_TYPES_FAILED',
}
